






















































import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment';
import pxCard from '@/dex-shared/components/px-card.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import Pagination from '@/components/Pagination.vue';

moment.locale('pt-BR');

export default Vue.extend({
  components: {
    pxCard,
    Loading,
    Pagination,
  },

  data() {
    return {
      loaded: true,
      currentPage: 0,
    };
  },

  computed: {
    ...mapGetters({
      feedbackQuestion: 'currentFeedbackQuestion',
    }),
    grouped: function() {
      return this.feedbackQuestion.responseType === 'boolean';
    },
  },

  async mounted() {
    await this.pullFeedBackQuestion();
  },

  methods: {
    formatTime(time: any) {
      return moment(time).fromNow();
    },
    pullFeedBackQuestion: async function() {
      let feedbackQuestionId = parseInt(this.$route.params.feedbackQuestionId);
      this.loaded = false;
      await this.$store.dispatch('PULL_FEEDBACK_QUESTION', {
        feedbackQuestionId,
        currentPage: this.currentPage,
      });
      this.loaded = true;
    },
    changePage: async function(event: any) {
      this.currentPage = event;
      await this.pullFeedBackQuestion();
    },
  },
});
